










import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("ui", ["headerType"]),
  },
})
export default class ToggleLanguage extends Vue {
  private headerType: string;

  get isLanguagesMenu() {
    return this.headerType === "languages";
  }
}
